import React from 'react';
import FlowReductionWizard from './FlowReductionWizard.js';
import { SHOWER_REDUCER_CATALOG } from './showerReducerCatalog.js';

const ShowerSubModule = ({ equipments, usages, waterPricing, onResultChange }) => (
  <FlowReductionWizard
    equipmentType="shower"
    equipmentTypeLabel="réducteur de débit"
    targetLabel="douche"
    targetLabelPlural="douches"
    moduleEyebrow="Douches"
    hasSubtypeGrouping={false}
    subtypeField={null}
    subtypeLabels={null}
    subtypeOrder={null}
    catalog={SHOWER_REDUCER_CATALOG}
    equipments={equipments}
    usages={usages}
    waterPricing={waterPricing}
    onResultChange={onResultChange}
  />
);

export default ShowerSubModule;
